import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

const HomeScreen = () => {
  const history = useHistory()
  useEffect(() => {
    history.replace('/dashboard')
  }, [history])
  return null
}

export default HomeScreen
